/* Southern Atelier – lightweight scroll-snap slider with arrows + optional progress bar */
(() => {
  if (customElements.get('sa-slider')) return;
  customElements.define('sa-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sa-track]');
      this.prev = this.querySelector('[data-sa-prev]');
      this.next = this.querySelector('[data-sa-next]');
      this.bar = this.querySelector('[data-sa-progress]');
      if (!this.track) return;
      const step = () => {
        const item = this.track.children[0];
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const per = Math.max(1, Math.floor(this.track.clientWidth / ((item?.offsetWidth || 1) + gap)));
        return per * ((item?.offsetWidth || this.track.clientWidth) + gap);
      };
      this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.next?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        if (this.bar) {
          const ratio = this.track.clientWidth / this.track.scrollWidth;
          this.bar.style.width = (ratio * 100) + '%';
          this.bar.style.transform = `translateX(${(this.track.scrollLeft / this.track.clientWidth) * 100}%)`;
        }
        this.dispatchEvent(new CustomEvent('sa:slide', { detail: { index: Math.round(this.track.scrollLeft / (this.track.children[0]?.offsetWidth || 1)) } }));
      };
      this.track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      new ResizeObserver(update).observe(this.track);
      update();
    }
    goTo(i) {
      const el = this.track?.children[i];
      if (el) this.track.scrollTo({ left: el.offsetLeft - this.track.offsetLeft - parseFloat(getComputedStyle(this.track).paddingLeft || 0), behavior: 'smooth' });
    }
  });
})();
